module.exports = __webpack_public_path__ + "img/lonxun-logo-01.7429f54a.png";